import Client from './Clients/AxiosClient'
import { parseFilters } from './utils/ParseFilters'
const resource = 'quickbooks_invoices'

export default {
  get (filters) {
    return Client.get(`${resource}?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  getQuickbooksInvoice (id, filters) {
    return Client.get(`${resource}/${id}?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  create (payload) {
    return Client.post(`${resource}`, payload)
      .then(response => response.data)
  },
  update (payload, id) {
    return Client.put(`${resource}/${id}`, payload)
      .then(response => response.data)
  },
  delete (id) {
    return Client.delete(`${resource}/${id}`)
      .then(response => response.data)
  },
  downloadInvoicePdf (token, invoiceNumber) {
    return Client.get(`${resource}/download_invoice_pdf/${invoiceNumber}?token=${token}`, {
      responseType: 'arraybuffer'
    })
      .then(response => response.data)
  },
  getInvoiceStatus (token, invoiceNumber) {
    return Client.get(`${resource}/check_qbo_status_invoice/${invoiceNumber}?token=${token}`)
      .then(response => response.data)
  }
}
